// extracted by mini-css-extract-plugin
module.exports = {"maincontainer":"container_maincontainer__2hzSS"};